<template>
  <div>
    <!--Header-->
    <div class="header bg-success pt-5 pb-7">
      <b-container>
        <div class="header-body">
          <b-row align-v="center" class="pt-5">
            <b-col lg="6">
              <div class="pr-5">
                <h2 class="display-4 text-white font-weight-light">
                  Welcome to
                </h2>
                <h1 class="display-2 text-white font-weight-bold mb-0">
                  Indian Commercial Pilots Association
                </h1>
                <h2 class="display-4 text-white font-weight-light">
                  UNITY ◈ INTEGRITY ◈ DIGNITY ◈ SAFETY
                </h2>
                <div class="mt-5">
                  <router-link
                    to="/dashboard"
                    class="btn btn-neutral my-2"
                    v-if="getToken"
                    >Explore Dashboard</router-link
                  >
                  <router-link
                    to="/auth/login"
                    class="btn btn-neutral my-2"
                    v-else
                    >Login</router-link
                  >
                  <a
                    href="https://www.icpaunion.com"
                    class="btn btn-default my-2"
                    >Fly to ICPA</a
                  >
                </div>
              </div>
            </b-col>
            <!-- <b-col lg="6">
              <b-row class="pt-5">
                <b-col md="6">
                  <b-card no-body>
                    <b-card-body >
                      <div class="icon icon-shape bg-gradient-red text-white rounded-circle shadow mb-4">
                        <i class="ni ni-active-40"></i>
                      </div>
                      <h5 class="h3">Components</h5>
                      <p>Argon comes with over 200 handcrafted components.</p>
                    </b-card-body>
                  </b-card>
                  <b-card no-body>
                    <b-card-body >
                      <div class="icon icon-shape bg-gradient-info text-white rounded-circle shadow mb-4">
                        <i class="ni ni-active-40"></i>
                      </div>
                      <h5 class="h3">Plugins</h5>
                      <p>Fully integrated and extendable third-party plugins that you will love.</p>
                    </b-card-body>
                  </b-card>
                </b-col>
                <b-col md="6" class="pt-lg-5 pt-4">
                  <b-card no-body class="mb-4">
                    <b-card-body >
                      <div class="icon icon-shape bg-gradient-success text-white rounded-circle shadow mb-4">
                        <i class="ni ni-active-40"></i>
                      </div>
                      <h5 class="h3">Pages</h5>
                      <p>From simple to complex, you get a beautiful set of 26 page examples.</p>
                    </b-card-body>
                  </b-card>
                  <b-card no-body class="mb-4">
                    <b-card-body >
                      <div class="icon icon-shape bg-gradient-warning text-white rounded-circle shadow mb-4">
                        <i class="ni ni-active-40"></i>
                      </div>
                      <h5 class="h3">Documentation</h5>
                      <p>You will love how easy is to to work with Argon.</p>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-col> -->
          </b-row>
        </div>
      </b-container>
      <!-- <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div> -->
    </div>
    <!-- Page content -->

    <!-- <section class="py-7">
      <b-container>
        <b-row class="row-grid justify-content-center">
          <b-col lg="8" class="text-center">
            <h2 class="display-3">Do you love this awesome <span class="text-success">Dashboard for BootstrapVue ?</span></h2>
            <p class="lead">Cause if you do, it can be yours now. Hit the button below to navigate to get the free version or purchase a license for your next project. Build a new web app or give an old BootstrapVue project a new look!</p>
            
          </b-col>
        </b-row>
      </b-container>
    </section> -->
  </div>
</template>
<script>
import { Tooltip } from "element-ui";
import { mapGetters } from "vuex";

export default {
  name: "home-page",
  computed: {
    ...mapGetters("user", ["getToken"])
  },
  components: {
    [Tooltip.name]: Tooltip
  }
};
</script>
